export type RaceSector = 'forest' | 'mountain' | 'tunnel' | 'sunset' | 'finish';

export function trackStops(questionCount: number): number[] {
  const count = Math.max(1, Math.min(10, Math.trunc(questionCount)));
  return Array.from({ length: count + 1 }, (_, index) => index / count);
}

export function progressAfterAnswer(answered: number, total: number, advance = true): number {
  const stops = trackStops(total);
  const index = Math.max(0, Math.min(stops.length - 1, Math.trunc(answered) + (advance ? 1 : 0)));
  return stops[index];
}

export function sectorForProgress(progress: number): RaceSector {
  const normalized = Math.max(0, Math.min(1, progress));
  if (normalized < 0.25) return 'forest';
  if (normalized < 0.5) return 'mountain';
  if (normalized < 0.7) return 'tunnel';
  if (normalized < 0.9) return 'sunset';
  return 'finish';
}
